module.exports = __webpack_public_path__ + "img/img_新闻04.32505c67.png";